import classNames from "classnames";
import { BaseButton } from "../../../components/Button/BaseButton.tsx";
import { Icon } from "../../../components/Icon/Icon.tsx";
import { QUICK_ACTIONS_CATEGORIES } from "./constants.ts";
import { CATEGORY_ICONS } from "./display.ts";
import { quickActionsDialogStore } from "./stores/quickActionsDialogStore.ts";
import type { QuickActionCategory } from "./types.ts";

export const QuickActionNavigation = () => {
  const { selectedCategory } = quickActionsDialogStore.useState();

  return (
    <div className="flex-col gap-100 w-[250px] px-300">
      {QUICK_ACTIONS_CATEGORIES.map((category) => (
        <QuickActionNavigationItem
          key={category}
          category={category}
          isActive={selectedCategory === category}
          onClick={() => {
            quickActionsDialogStore.selectCategory(category);
          }}
        />
      ))}
    </div>
  );
};

const QuickActionNavigationItem = ({
  category,
  isActive,
  onClick,
}: {
  category: QuickActionCategory;
  isActive: boolean;
  onClick: () => void;
}) => (
  <BaseButton
    key={category}
    onClick={onClick}
    className={classNames(
      "flex-row items-center h-800 pl-150 pr-200 gap-150 text-primary rounded-150",
      isActive
        ? "bg-surface-secondary-active label-md-semibold"
        : "hover:bg-surface-secondary-hover label-md-default",
    )}
  >
    <Icon name={CATEGORY_ICONS[category]} size="sm" />
    {category}
  </BaseButton>
);
